import { apiCreate, apiList } from './apiClient';

export async function logAuditEvent(event: {
  property_id?: number | string;
  device_id?: number | string;
  tenant_id?: number | string;
  user_id?: number | string;
  event_type: string;
  event_source?: string;
  description: string;
  metadata?: any;
  acs_system_id?: number | string;
}) {
  try {
    return await apiCreate('audit_events', {
      action: event.event_type,
      entity_type: event.event_source || 'system',
      entity_id: event.acs_system_id || event.device_id || event.property_id || 0,
      user_id: event.user_id || 0,
      new_value_json: {
        description: event.description,
        property_id: event.property_id,
        device_id: event.device_id,
        tenant_id: event.tenant_id,
        event_source: event.event_source,
        ...(event.metadata || {}),
      },
    });
  } catch (e) {
    console.error('Failed to log audit event:', e);
  }
}

export async function getAuditEventsForSystem(systemId: number, propertyId?: number): Promise<any[]> {
  try {
    const all = await apiList('audit_events');
    return (Array.isArray(all) ? all : [])
      .filter((e: any) => {
        // Match by entity_id (direct system reference)
        if (e.entity_id === systemId) return true;
        // Match by property_id stored in new_value_json
        const meta = typeof e.new_value_json === 'string' ? JSON.parse(e.new_value_json) : e.new_value_json;
        if (meta?.property_id === propertyId && (
          e.entity_type === 'pdk' || e.entity_type === 'seam' || e.entity_type === 'acs' ||
          e.action?.includes('system') || e.action?.includes('holder') || e.action?.includes('device')
        )) return true;
        return false;
      })
      .map((e: any) => {
        const meta = typeof e.new_value_json === 'string'
          ? (() => { try { return JSON.parse(e.new_value_json); } catch { return {}; } })()
          : (e.new_value_json || {});
        return {
          id: e.id,
          event_type: e.action || 'unknown',
          event_source: e.entity_type || meta.event_source || '',
          description: meta.description || e.action || '',
          property_id: meta.property_id,
          created_at: e.created_at,
          metadata: meta,
        };
      })
      .sort((a: any, b: any) => {
        const ta = typeof a.created_at === 'number' ? a.created_at : new Date(a.created_at).getTime();
        const tb = typeof b.created_at === 'number' ? b.created_at : new Date(b.created_at).getTime();
        return tb - ta;
      });
  } catch (e) {
    console.error('Failed to load audit events:', e);
    return [];
  }
}
